export default __webpack_public_path__ + "static/media/Mask Group 11.1e852e24.png";